import { MixpanelEvent, MixpanelEventProperty, MixpanelEventSource, useMixpanel, useOnKeyDown } from '@talos/kyoko';
import { useCallback } from 'react';
import { useAvaAIVisibility } from '../../providers/AvaAIContext';
import { AVA_AI_SHORTCUT_KEY } from './tokens';

export function AvaAIShortcut() {
  const { isEnabled, isOpen, isPopped, open, close, focusPopout } = useAvaAIVisibility();
  const mixpanel = useMixpanel();

  const handleCmdI = useCallback(() => {
    if (!isEnabled) {
      return;
    }
    if (isPopped) {
      focusPopout();
      return;
    }
    if (isOpen) {
      close();
      return;
    }
    mixpanel.track(MixpanelEvent.OpenAvaAI, {
      [MixpanelEventProperty.Source]: MixpanelEventSource.KeyboardShortcut,
    });
    open();
  }, [isEnabled, isOpen, isPopped, open, close, focusPopout, mixpanel]);

  useOnKeyDown(AVA_AI_SHORTCUT_KEY, isEnabled ? handleCmdI : undefined);

  return null;
}
